import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/glassButtons.css";
import App from "./App";
import { initNativeResumeRepaint } from "./utils/nativeResumeRepaint";
import { initDiagnostics } from "./utils/diagLog";

initDiagnostics();
initNativeResumeRepaint();

// Global error handlers for debugging OAuth and other issues
window.addEventListener("error", (e) => {
  console.error("[GlobalError]:", e.error || e.message, e);
});

window.addEventListener("unhandledrejection", (e) => {
  console.error("[UnhandledRejection]:", e.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Health flag for the native resume check (MainActivity.healthCheckAndRecover):
// present only when this JS context is alive and executing the bundled app.
window.__wasslaAlive = true;
